<div class="flex-container" fxLayout="column">
  <div fxLayout="row" fxLayoutAlign="center">
    <h1>{{ 'core.headline' | translate }}</h1>
  </div>
  <div fxLayout="row" fxLayoutAlign="center" class="card-container">
    <div fxFlex="90%" fxFlex.md="50%" fxFlex.gt-md="30%">
      <mat-card appearance="outlined">
        <mat-card-title>{{ 'auth.login' | translate }}</mat-card-title>
        <mat-card-content>
          @if (error$ | async) {
            <div class="error-message">{{ error$ | async }}</div>
          }
          @if (!(isPending$ | async)) {
            <form novalidate>
              <div fxLayout="column">
                <mat-form-field>
                  <input matInput [placeholder]="'user.email' | translate" [(ngModel)]="username" name="username" required>
                </mat-form-field>
                <mat-form-field>
                  <input matInput [placeholder]="'user.password' | translate" [(ngModel)]="password" type="password" name="password" required>
                </mat-form-field>
                <button mat-raised-button (click)="onLogin()" color="primary">{{ 'auth.login' | translate }}</button>
              </div>
            </form>
          }
          <div fxLayout="row" fxLayoutAlign="center">
            @if (isPending$ | async) {
              <mat-spinner></mat-spinner>
            }
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  </div>
</div>
